import { render, staticRenderFns } from "./SystemComponentChangeActivationType.vue?vue&type=template&id=995d7d96&"
import script from "./SystemComponentChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./SystemComponentChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports